import {
  Beenhere,
  CardTravel,
  ChevronRight,
  ContactsTwoTone,
  Dashboard,
  FaceTwoTone,
  HomeTwoTone,
  ListAlt,
  Settings,
  ShowChart
} from "@material-ui/icons";
import AccountBalanceWalletOutlinedIcon from "@material-ui/icons/AccountBalanceWalletOutlined";
import AirlineSeatIndividualSuiteOutlinedIcon from "@material-ui/icons/AirlineSeatIndividualSuiteOutlined";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import TreeView from "@material-ui/lab/TreeView";
import AccountCircle from "@mui/icons-material/AccountCircle";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import CalculateIcon from '@mui/icons-material/Calculate';
import EditOffOutlinedIcon from "@mui/icons-material/EditOffOutlined";
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import FolderSharedIcon from '@mui/icons-material/FolderShared';
import MailIcon from "@mui/icons-material/Mail";
import MeetingRoomOutlinedIcon from "@mui/icons-material/MeetingRoomOutlined";
import MonitorIcon from "@mui/icons-material/Monitor";
import PsychologyAltOutlinedIcon from "@mui/icons-material/PsychologyAltOutlined";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import SecurityIcon from '@mui/icons-material/Security';
import ShopIcon from "@mui/icons-material/Shop";
import TaskIcon from '@mui/icons-material/Task';
import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { userDetailContext } from "../App";
import AuthService from "../services/AuthService";
import PlanningService from "../services/PlanningService";
import { hasPrivilege } from "../utils/privilege";
import StyledTreeItem from "./StyledTreeItem";
import useStyles from "./styledtreeitem.styles";

function SidebarTreeView({ onNavigate }) {
  const classes = useStyles();
  const [id, setId] = useState(0);
  const [idSupSpecial, setIdSupSpecial] = useState(0);
  const [showTitlePreProd, setShowTitlePreProd] = useState(false);
  
  const handleLogOut = (e) => {
    AuthService.logOut();
  };
  
  useEffect(() => {
    PlanningService.getUser().then((result) => {
      if (result) {
        setId(result.data);
        setIdSupSpecial(result.dataSpecial);
      }
    });
    if (window.location.hostname === "2fidmg.mg") {
      setShowTitlePreProd(true);
    }
  }, []);
  
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  const contextData = useContext(userDetailContext);

  // Initialisation de expanded avec gestion du localStorage
  const getInitialExpanded = () => {
    const stored = localStorage.getItem("EXPANDED");
    if (stored && stored.length > 0) {
      return [stored.substring(0, 1), stored.substring(0, 3)];
    }
    return ["0"];
  };

  const [expanded, setExpanded] = React.useState(getInitialExpanded());
  const [currentId, setCurrentId] = React.useState(
    () => localStorage.getItem("EXPANDED")?.substring(0, 3) || "0"
  );
  
  const handleToggle = (event, nodeIds) => {
    setExpanded(nodeIds);
  };
  
  const handleToggleSelected = (event, nodeIds) => {
    if (nodeIds?.trim?.()?.length !== 0 && nodeIds) {
      localStorage.setItem("EXPANDED", nodeIds + "-1");
      setCurrentId(nodeIds);
    }
  };
  
  const handleExpandClick = () => {
    setExpanded((oldExpanded) =>
      oldExpanded.length === 0 ? ["1", "2", "3", "4", "5", "6", "7"] : []
    );
  };
  
  const handleExpandClickGed = () => {
    setExpanded((oldExpanded) => (oldExpanded.length <= 1 ? [""] : ["b"]));
  };
  
  const handleExpandClickValidation = () => {
    setExpanded((oldExpanded) => (oldExpanded.length <= 1 ? [""] : ["2"]));
  };
  
  const handleExpandClickAdmin = () => {
    setExpanded((oldExpanded) => (oldExpanded.length <= 1 ? [""] : ["3"]));
  };
  
  const handleExpandClickSetting = () => {
    setExpanded((oldExpanded) => (oldExpanded.length <= 1 ? [""] : ["4"]));
  };
  
  const handleExpandClickRh = () => {
    setExpanded((oldExpanded) => (oldExpanded.length <= 1 ? [""] : ["5"]));
  };
  
  const handleExpandClickLogistic = () => {
    setExpanded((oldExpanded) => (oldExpanded.length <= 1 ? [""] : ["9"]));
  };
  
  const handleExpandClickBanqueCV = () => {
    setExpanded((oldExpanded) => (oldExpanded.length <= 1 ? [""] : ["6"]));
  };
  
  const handleExpandClickMission = () => {
    setExpanded((oldExpanded) => (oldExpanded.length <= 1 ? [""] : ["7"]));
  };
  
  const handleExpandClickState = () => {
    setExpanded((oldExpanded) => (oldExpanded.length <= 1 ? [""] : ["1"]));
  };
  
  const handleExpandClickAccueil = () => {
    setExpanded(["0"]);
  };
  
  const handleExpandClickCommun = () => {
    setExpanded((oldExpanded) => (oldExpanded.length === 2 ? ["4-1"] : [""]));
  };
  
  const handleExpandClickMail = () => {
    setExpanded((oldExpanded) => (oldExpanded.length <= 1 ? [""] : ["10"]));
  };
  
  const handleExpandClickPersonnalEvaluation = () => {
    setExpanded((oldExpanded) => (oldExpanded.length <= 1 ? [""] : ["a"]));
  };
  
  const handleExpandClickContract = () => {
    setExpanded((oldExpanded) => (oldExpanded.length <= 1 ? [""] : ["f"]));
  };

  const handleExpandClickFormation = () => {
    setExpanded((oldExpanded) => (oldExpanded.length <= 1 ? [""] : ["g"]));
  };
  

  const handleExpandClickCircuitValidation = () => {
    setExpanded((oldExpanded) => (oldExpanded.length <= 1 ? [""] : ["c"]));
  };
  
  const handleExpandClickMesMateriels = () => {
    setExpanded((oldExpanded) => (oldExpanded.length <= 1 ? [""] : ["j"]));
  };
  
  const handleExpandClickPersonnalEvaluationParametre = () => {
    setExpanded((oldExpanded) => (oldExpanded.length <= 1 ? [""] : ["a-2"]));
  };
  
  const handleExpandClickSecurity = () => {
    setExpanded((oldExpanded) => (oldExpanded.length <= 1 ? [""] : ["d"]));
  };
 
  const handleExpandClickComptable = () => {
    setExpanded((oldExpanded) => (oldExpanded.length <= 1 ? [""] : ["8"]));
  };

  // Valeur pour expanded du TreeView
  const expandedValue = expanded && expanded.length > 0 ? expanded : (currentId ? [currentId] : ["0"]);

  const handleNavigate = React.useCallback((event) => {
    if (typeof onNavigate !== "function") {
      return;
    }

    if (event.target?.closest?.("a[href]")) {
      onNavigate();
    }
  }, [onNavigate]);

  //Fin parametrage
  return (
    <>
      {showTitlePreProd && (
        <h2 style={{ color: "red", fontWeight: "bold" }}>SERVEUR TEST</h2>
      )}
      {!showTitlePreProd && (
        <strong style={{ color: "red", fontSize: "20px" }}>
          Version 1.0.2
        </strong>
      )}

      <TreeView
        className={classes.treeView}
        defaultExpanded={[
          "0",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8w",
          "9",
          "10",
          "a",
          "b",
          "c",
          "d",
          "e",
          "3-1",
          "3-1-1",
          "3-1-2",
          "3-1-3",
          "3-2",
          "3-2-1",
          "3-2-2",
          "3-3",
          "3-3-1",
          "i",
          "f",
          "g"
        ]}
        defaultCollapseIcon={<ArrowDropDownIcon />}
        defaultExpandIcon={<ArrowRightIcon />}
        expanded={expandedValue}
        onNodeToggle={handleToggle}
        onNodeSelect={handleToggleSelected}
        onClick={handleNavigate}
        defaultEndIcon={<div style={{ width: 24 }} />}
        style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
      >
        <StyledTreeItem
          nodeId="0"
          labelText="Accueil"
          labelIcon={HomeTwoTone}
          onClick={handleExpandClickAccueil}
          isBold={true}
          link={"/home"}
          isActiveMenu={splitLocation.includes("home")}
        >
        </StyledTreeItem>
        
        {hasPrivilege(contextData.privileges, "tableau_bord") && (
          <StyledTreeItem
            nodeId="e"
            labelText="Tableau de bord"
            labelIcon={Dashboard}
            link="/dashboard"
            isBold={true}
            isActiveMenu={pathname === "/dashboard"}
          >
          </StyledTreeItem>
        )}

        {hasPrivilege(contextData.privileges, "etat") && (
          <StyledTreeItem
            nodeId="1"
            labelText="Etat"
            labelIcon={TaskIcon}
            link="/dashboard"
            onClick={handleExpandClickState}
            isBold={true}
          >
            <StyledTreeItem
              nodeId="1-1"
              labelText="Congé"
              labelIcon={AirlineSeatIndividualSuiteOutlinedIcon}
              isBold={true}
              link="/dashboard"
            >
              <StyledTreeItem
                nodeId="1-1-1"
                labelText="Rapport d'activité mensuel"
                link="/monthlyreport"
                labelIcon={ChevronRight}
                isActiveMenu={splitLocation.includes("monthlyreport")}
              />
              <StyledTreeItem
                nodeId="1-1-5"
                labelText="Historique du solde"
                link="/balancehistory"
                labelIcon={ChevronRight}
                isActiveMenu={splitLocation.includes("balancehistory")}
              />
              {hasPrivilege(contextData.privileges, "Recap_conge") && (
                <StyledTreeItem
                  nodeId="1-1-7"
                  labelText="Suivi activité mensuelle"
                  link="/recapleave"
                  isActiveMenu={splitLocation.includes("recapleave")}
                  labelIcon={ChevronRight}
                />
              )}
            </StyledTreeItem>
            
            <StyledTreeItem
              nodeId="1-2"
              labelText="Mission"
              labelIcon={AssignmentIcon}
              isBold={true}
              link="/mission_dashboard"
            >
              <StyledTreeItem
                nodeId="1-2-1"
                labelText="Liste des planning"
                link="/mission_planning"
                labelIcon={ChevronRight}
                isActiveMenu={splitLocation.includes("mission_planning")}
              />
              <StyledTreeItem
                nodeId="1-2-2"
                labelText="Liste des missions"
                link="/mission_dashboard"
                labelIcon={ChevronRight}
                isActiveMenu={splitLocation.includes("mission_dashboard")}
              />
              <StyledTreeItem
                nodeId="1-2-3"
                labelText="Mission/TDR"
                link="/mission_etat"
                labelIcon={ChevronRight}
                isActiveMenu={splitLocation.includes("mission_etat")}
              />
              <StyledTreeItem
                nodeId="1-2-4"
                labelText="Suivi des rapports de mission"
                link="/report_mission"
                labelIcon={ChevronRight}
                isActiveMenu={splitLocation.includes("report_mission")}
              />
              {hasPrivilege(contextData.privileges, "mission_graphe") && (
                <>
                  <StyledTreeItem
                    nodeId="1-2-5"
                    labelText="Suivi du nombre de missions effectuées"
                    link="/mission_graphe"
                    labelIcon={ChevronRight}
                    isActiveMenu={splitLocation.includes("mission_graphe")}
                  />
                  <StyledTreeItem
                    nodeId="1-2-6"
                    labelText="Suivi de l'activité par mission"
                    link="/suiviagenda"
                    labelIcon={ChevronRight}
                    isActiveMenu={splitLocation.includes("suiviagenda")}
                  />
                </>
              )}
            </StyledTreeItem>
            
            {hasPrivilege(contextData.privileges, "timetracking_report") && (
              <StyledTreeItem
                nodeId="1-3"
                labelText="Pointage"
                labelIcon={EventAvailableIcon}
                isBold={true}
                link="/timeTracking_report"
              >
                <StyledTreeItem
                  nodeId="1-3-1"
                  labelText="Situation Présence"
                  link="/timeTracking_report"
                  labelIcon={ChevronRight}
                  isActiveMenu={splitLocation.includes("timeTracking_report")}
                />
                 <StyledTreeItem
                  nodeId="1-3-2"
                  labelText="Situation Présence Gardien"
                  link="/time_gardian"
                  labelIcon={ChevronRight}
                  isActiveMenu={splitLocation.includes("time_gardian")}
                />
                <StyledTreeItem
                  nodeId="1-3-3"
                  labelText="Situation Présence stagiaire"
                  link="/timeTracking_stg"
                  labelIcon={ChevronRight}
                  isActiveMenu={splitLocation.includes("timeTracking_stg")}
                />
                {hasPrivilege(contextData.privileges, "History_pointagemanuel") && (
                    <StyledTreeItem
                      nodeId="1-3-4"
                      labelText="Historique pointage manuel"
                      link="/time_provisional"
                      labelIcon={ChevronRight}
                      isActiveMenu={splitLocation.includes("time_provisional")}
                    />
                 )}
              </StyledTreeItem>
            )}
            
            {hasPrivilege(contextData.privileges, "Gestion_affectation") && (
              <StyledTreeItem
                nodeId="1-4"
                labelText="Suivi RH"
                labelIcon={AssignmentIndIcon}
                isBold={true}
                link="/assignment"
              >
                <StyledTreeItem
                  nodeId="1-4-1"
                  labelText="Historique du personnel"
                  labelIcon={ChevronRight}
                  link="/assignment"
                  isActiveMenu={splitLocation.includes("assignment")}
                />
                <StyledTreeItem
                  nodeId="1-4-2"
                  labelText="Historique de sortie de la personne"
                  labelIcon={ChevronRight}
                  link="/suivisortie"
                  isActiveMenu={splitLocation.includes("suivisortie")}
                />
                <StyledTreeItem
                  nodeId="1-4-3"
                  labelText="Historique des congés sans solde et congés de maternité"
                  labelIcon={ChevronRight}
                  link="/suivisanssolde"
                  isActiveMenu={splitLocation.includes("suivisanssolde")}
                />
                <StyledTreeItem
                  nodeId="1-4-4"
                  labelText="Historique des affectations"
                  labelIcon={ChevronRight}
                  link="/suiviassignement"
                  isActiveMenu={splitLocation.includes("suiviassignement")}
                />
                <StyledTreeItem
                  nodeId="1-4-5"
                  labelText="Historique des réintegrations"
                  labelIcon={ChevronRight}
                  link="/historyintegration"
                  isActiveMenu={splitLocation.includes("historyintegration")}
                />
                <StyledTreeItem
                  nodeId="1-4-6"
                  labelText="Historique des recrutements"
                  labelIcon={ChevronRight}
                  link="/historyrecrutment"
                  isActiveMenu={splitLocation.includes("historyrecrutment")}
                />
                <StyledTreeItem
                  nodeId="1-4-7"
                  labelText="Historique de la répartition du personnel par financement"
                  labelIcon={ChevronRight}
                  link="/suivifunding"
                  isActiveMenu={splitLocation.includes("suivifunding")}
                />
              </StyledTreeItem>
            )}
          </StyledTreeItem>
        )}
       
        {hasPrivilege(contextData.privileges, "Ged_file") && (
          <StyledTreeItem
            nodeId="b"
            labelText="GED"
            labelIcon={AssignmentOutlinedIcon}
            isBold={true}
            isActiveMenu={false}
            onClick={handleExpandClickGed}
            link="/rubrique"
          >
            <StyledTreeItem
              nodeId="b-1"
              labelText="Rubrique"
              labelIcon={ChevronRight}
              link="/rubrique"
              isActiveMenu={splitLocation.includes("rubrique")}
            />
            <StyledTreeItem
              nodeId="b-2"
              labelText="Document"
              labelIcon={ChevronRight}
              link="/document"
              isActiveMenu={splitLocation.includes("document")}
            />
            <StyledTreeItem
              nodeId="b-3"
              labelText="Emplacement"
              labelIcon={ChevronRight}
              link="/emplacement"
              isActiveMenu={splitLocation.includes("emplacement")}
            />
          </StyledTreeItem>
        )}

        {hasPrivilege(contextData.privileges, "Other-Me-Validations") && (
          <>
            <StyledTreeItem
              style={{ display: "none" }}
              nodeId="c"
              labelText="Circuit validation"
              labelIcon={PublishedWithChangesIcon}
              isBold={true}
              isActiveMenu={false}
              onClick={handleExpandClickCircuitValidation}
              link="/demandes_en_cours"
            >
              <StyledTreeItem
                nodeId="c-1"
                labelText="En cours"
                labelIcon={ChevronRight}
                link="/demandes_en_cours"
                isActiveMenu={pathname === "/demandes_en_cours"}
              />
              <StyledTreeItem
                nodeId="c-2"
                labelText="Validée(s)"
                labelIcon={ChevronRight}
                link="/demandes_validees"
                isActiveMenu={pathname === "/demandes_validees"}
              />
              <StyledTreeItem
                nodeId="c-3"
                labelText="Refusée(s)"
                labelIcon={ChevronRight}
                link="/demandes_refusees"
                isActiveMenu={pathname === "/demandes_refusees"}
              />
              <StyledTreeItem
                nodeId="c-4"
                labelText="Mes validateurs"
                labelIcon={ChevronRight}
                link="/myValidators"
                isActiveMenu={pathname === "/myValidators"}
              />
            </StyledTreeItem>
            
        
          
          <StyledTreeItem
            style={{ display: "none" }}
            nodeId="c"
            labelText="Circuit validation"
            labelIcon={PublishedWithChangesIcon}
            isBold={true}
            isActiveMenu={false}
            onClick={handleExpandClickCircuitValidation}
            link="/demandes_en_cours"
          >
            <StyledTreeItem
              nodeId="c-1"
              labelText="En cours"
              labelIcon={ChevronRight}
              link="/demandes_en_cours"
              isActiveMenu={pathname === "/demandes_en_cours" ? true : false}
            />
            <StyledTreeItem
              nodeId="c-2"
              labelText="Validée(s)"
              labelIcon={ChevronRight}
              link="/demandes_validees"
              isActiveMenu={pathname === "/demandes_validees" ? true : false}
            />
            <StyledTreeItem
              nodeId="c-3"
              labelText="Refusée(s)"
              labelIcon={ChevronRight}
              link="/demandes_refusees"
              isActiveMenu={pathname === "/demandes_refusees" ? true : false}
            />
            <StyledTreeItem
              nodeId="c-4"
              labelText="Mes validateurs"
              labelIcon={ChevronRight}
              link="/myValidators"
              isActiveMenu={pathname === "/myValidators" ? true : false}
            />
          </StyledTreeItem>
          </>
        )}
        {hasPrivilege(contextData.privileges, "Other-Me-Validations") && (
          <StyledTreeItem
            nodeId="2"
            labelText="Mes validations"
            labelIcon={Beenhere}
            isBold={true}
            isActiveMenu={false}
            onClick={handleExpandClickValidation}
            link="/me/validations"
          >
            <StyledTreeItem
              nodeId="2-1"
              labelText="Réelles"
              labelIcon={ChevronRight}
              link="/me/validations"
              isActiveMenu={
                splitLocation.includes("validations") ? true : false
              }
            />

            <StyledTreeItem
              nodeId="2-6"
              labelText="Mes demandes en attente de validation"
              labelIcon={ChevronRight}
              link="/me/pendings"
              isActiveMenu={
                splitLocation.includes("pendings") ? true : false
              }
            />

            <StyledTreeItem
              nodeId="2-7"
              labelText="Les demandes dont j'ai pris part"
              labelIcon={ChevronRight}
              link="/me/participate"
              isActiveMenu={
                splitLocation.includes("participate") ? true : false
              }
            />

               <StyledTreeItem
              nodeId="2-8"
              labelText="Status de mes demandes"
              labelIcon={ChevronRight}
              link="/me/requeststate"
              isActiveMenu={
                splitLocation.includes("requeststate") ? true : false
              }
            /> 
            {((id != undefined && id.length > 0) ||
              (idSupSpecial != undefined && idSupSpecial.length > 0)) && (
              <StyledTreeItem
                nodeId="2-3"
                labelText="Plannings congés"
                labelIcon={ChevronRight}
                link="/planning/table"
                isActiveMenu={splitLocation.includes("table") ? true : false}
              />
            )}
            {((id != undefined && id.length > 0) ||
              (idSupSpecial != undefined && idSupSpecial.length > 0)) && (
              <StyledTreeItem
                nodeId="2-4"
                labelText="Plannings missions"
                labelIcon={ChevronRight}
                link="/me/missions"
                isActiveMenu={splitLocation.includes("missions") ? true : false}
              />
            )}
            {/* {((id != undefined && id.length > 0) ||
              (idSupSpecial != undefined && idSupSpecial.length > 0)) && ( */}
              <StyledTreeItem
                nodeId="2-5"
                labelText="Pointage manuel"
                labelIcon={ChevronRight}
                link="/me/tracking"
                isActiveMenu={pathname === "/me/tracking" ? true : false}
              />
            {/* )} */}
            <StyledTreeItem
              nodeId="2-1"
              labelText="Immobilisations"
              labelIcon={ChevronRight}
              link="/logistic/myValidations"
              isActiveMenu={
                pathname === "/logistic/myValidations" ? true : false
              }
            />
             <StyledTreeItem
                  nodeId="2-2"
                  labelText="Carburants / indemnités prévisionnels"
                  link="/mission/fuel_forecast"
                  labelIcon={ChevronRight}
                  isActiveMenu={splitLocation.includes("fuel_forecast") ? true : false}
                />
          </StyledTreeItem>
        )}

        {hasPrivilege(contextData.privileges, "Admin") && (
          <StyledTreeItem
            nodeId="3"
            labelText="Administration"
            labelIcon={ContactsTwoTone}
            isBold={true}
            disabled
            link="/groups"
            onClick={handleExpandClickAdmin}
          >
            {hasPrivilege(contextData.privileges, "Admin-Group-List") && (
              <StyledTreeItem
                nodeId="3-1"
                labelText="Groupes"
                labelIcon={ChevronRight}
                link="/groups"
                isActiveMenu={splitLocation.includes("groups")}
              />
            )}
            {hasPrivilege(contextData.privileges, "Admin-User-List") && (
              <StyledTreeItem
                nodeId="3-2"
                labelText="Utilisateurs"
                labelIcon={ChevronRight}
                link="/users"
                isActiveMenu={splitLocation.includes("users")}
              />
            )}
            {hasPrivilege(contextData.privileges, "Admin-User-List") && (
              <StyledTreeItem
                nodeId="3-3"
                labelText="Stagiaires"
                labelIcon={ChevronRight}
                link="/stglist"
                isActiveMenu={splitLocation.includes("stglist")}
              />
            )}
            {hasPrivilege(contextData.privileges, "Admin-Privilege-List") && (
              <StyledTreeItem
                nodeId="3-4"
                labelText="Privilèges"
                labelIcon={ChevronRight}
                link="/privileges"
                isActiveMenu={splitLocation.includes("privileges")}
              />
            )}
            {hasPrivilege(contextData.privileges, "Admin-Privilege-List") && (
              <StyledTreeItem
                nodeId="3-5"
                labelText="Fonctions"
                labelIcon={ChevronRight}
                link="/fonction"
                isActiveMenu={splitLocation.includes("fonction")}
              />
            )}
            {hasPrivilege(contextData.privileges, "Admin-Privilege-List") && (
              <StyledTreeItem
                nodeId="3-6"
                labelText="Directions"
                labelIcon={ChevronRight}
                link="/direction"
                isActiveMenu={splitLocation.includes("direction")}
              />
            )}
            {hasPrivilege(contextData.privileges, "Admin-Privilege-List") && (
              <StyledTreeItem
                nodeId="3-7"
                labelText="Antennes"
                labelIcon={ChevronRight}
                link="/antenne"
                isActiveMenu={splitLocation.includes("antenne")}
              />
            )}
            {hasPrivilege(contextData.privileges, "Admin") && (
              <StyledTreeItem
                nodeId="3-8"
                labelText="Services"
                labelIcon={ChevronRight}
                link="/services"
                isActiveMenu={splitLocation.includes("services")}
              />
            )}
            {hasPrivilege(contextData.privileges, "Admin-Group-List") && (
              <StyledTreeItem
                nodeId="3-9"
                labelText="Bureau"
                labelIcon={ChevronRight}
                link="/seat"
                isActiveMenu={splitLocation.includes("bureau")}
              />
            )}
            {hasPrivilege(contextData.privileges, "Admin-Group-List") && (
              <StyledTreeItem
                nodeId="3-10"
                labelText="Batiment"
                labelIcon={ChevronRight}
                link="/building"
                isActiveMenu={splitLocation.includes("batiment")}
              />
            )}
          </StyledTreeItem>
        )}

        {hasPrivilege(contextData.privileges, "RH_parametrage") && (
          <StyledTreeItem
            nodeId="4"
            labelText="Paramétrage"
            labelIcon={Settings}
            isBold={true}
            link="/funding"
            onClick={handleExpandClickSetting}
          >
            {hasPrivilege(contextData.privileges, "Other-Me-Validations") && (
              <StyledTreeItem
                nodeId="4-1"
                labelText="Commun"
                labelIcon={AccountBalanceWalletOutlinedIcon}
                isBold={true}
                link="/funding"
              >
                <StyledTreeItem
                  nodeId="4-1-1"
                  labelText="Financement"
                  link="/funding"
                  labelIcon={ChevronRight}
                  isActiveMenu={splitLocation.includes("funding")}
                />
              </StyledTreeItem>
            )}
            
            {hasPrivilege(contextData.privileges, "Other-Me-Validations") && (
              <StyledTreeItem
                nodeId="4-2"
                labelText="Congé"
                isBold={true}
                labelIcon={AirlineSeatIndividualSuiteOutlinedIcon}
                link="/leave_type"
              >
                <StyledTreeItem
                  nodeId="4-2-1"
                  labelText="Facteurs de comptage"
                  link="/leave_type"
                  labelIcon={ChevronRight}
                  isActiveMenu={splitLocation.includes("leave_type")}
                />
                <StyledTreeItem
                  nodeId="4-2-2"
                  labelText="Jours non comptabilisés"
                  link="/annual_calendar"
                  labelIcon={ChevronRight}
                  isActiveMenu={splitLocation.includes("annual_calendar")}
                />
                <StyledTreeItem
                  nodeId="4-2-3"
                  labelText="Période de validation"
                  link="/validation_planning"
                  labelIcon={ChevronRight}
                  isActiveMenu={splitLocation.includes("validation_planning")}
                />
                {hasPrivilege(contextData.privileges, "balance_configuration") && (
                  <StyledTreeItem
                    nodeId="4-2-4"
                    labelText="Configuration solde"
                    link="/balance_configuration"
                    labelIcon={ChevronRight}
                    isActiveMenu={splitLocation.includes("balance_configuration")}
                  />
                )}
                {hasPrivilege(contextData.privileges, "maternity_leave") && (
                  <StyledTreeItem
                    nodeId="4-2-5"
                    labelText="Congé de maternité /sans solde"
                    link="/maternity_leave"
                    labelIcon={ChevronRight}
                    isActiveMenu={splitLocation.includes("maternity_leave")}
                  />
                )}
                {hasPrivilege(contextData.privileges, "annual_leave") && (
                  <StyledTreeItem
                    nodeId="4-2-6"
                    labelText="Congé annuel"
                    link="/annual_leave"
                    labelIcon={ChevronRight}
                    isActiveMenu={splitLocation.includes("annual_leave")}
                  />
                )}
              </StyledTreeItem>
            )}
            
            {hasPrivilege(contextData.privileges, "Other-Me-Validations") && (
              <StyledTreeItem
                nodeId="4-3"
                labelText="Personnel"
                isBold={true}
                labelIcon={AssignmentIndOutlinedIcon}
                link="/champ_dynamique"
              >
                <StyledTreeItem
                  nodeId="4-3-1"
                  labelText="Champ dynamique"
                  link="/champ_dynamique"
                  labelIcon={ChevronRight}
                  isActiveMenu={splitLocation.includes("champ_dynamique")}
                />
              </StyledTreeItem>
            )}
            
            {hasPrivilege(contextData.privileges, "Other-Me-Validations") && (
              <StyledTreeItem
                nodeId="4-4"
                labelText="Candidature"
                isBold={true}
                labelIcon={AssignmentIndOutlinedIcon}
                link="/list_candidature"
              >
                <StyledTreeItem
                  nodeId="4-4-1"
                  labelText="Configuration AMI(interne/externe)"
                  link="/list_candidature"
                  labelIcon={ChevronRight}
                  isActiveMenu={splitLocation.includes("list_candidature")}
                />
              </StyledTreeItem>
            )}
            
            {hasPrivilege(contextData.privileges, "Other-Me-Validations") && (
              <StyledTreeItem
                nodeId="4-5"
                labelText="Mission"
                isBold={true}
                labelIcon={AssignmentIcon}
                link="/mission_category"
              >
                <StyledTreeItem
                  nodeId="4-5-1"
                  labelText="Catégorie mission"
                  link="/mission_category"
                  labelIcon={ChevronRight}
                  isActiveMenu={splitLocation.includes("mission_category")}
                />
                <StyledTreeItem
                  nodeId="4-5-2"
                  labelText="Suite de la demande d'appui"
                  link="/mission_reponse"
                  labelIcon={ChevronRight}
                  isActiveMenu={splitLocation.includes("mission_reponse")}
                />
                {/* <StyledTreeItem
                  nodeId="4-5-3"
                  labelText="Nombre de validation par direction"
                  link="/mission_dir"
                  labelIcon={ChevronRight}
                  isActiveMenu={splitLocation.includes("mission_dir")}
                /> */}
                <StyledTreeItem
                  nodeId="4-5-4"
                  labelText="Période de validation"
                  link="/mission_periode"
                  labelIcon={ChevronRight}
                  isActiveMenu={splitLocation.includes("mission_periode")}
                />
                <StyledTreeItem
                  nodeId="4-5-5"
                  labelText="Configuration mail"
                  link="/mission_mail"
                  labelIcon={ChevronRight}
                  isActiveMenu={splitLocation.includes("mission_mail")}
                />
              </StyledTreeItem>
            )}
            
            <StyledTreeItem
              nodeId="4-6"
              labelText="Evaluation du personnel"
              link="/evaluation_saison"
              labelIcon={PsychologyAltOutlinedIcon}
              isBold={true}
            >
              <StyledTreeItem
                nodeId="4-6-1"
                labelText="Session d'evaluation"
                labelIcon={ChevronRight}
                link="/evaluation_saison"
                isActiveMenu={
                  splitLocation.includes("evaluation_saison") ||
                  splitLocation.includes("evaluation_fonctions_list")
                }
              />
              <StyledTreeItem
                nodeId="4-6-4"
                labelText="Fiche d'evaluation"
                labelIcon={ChevronRight}
                link="/critere_groupee"
                isActiveMenu={
                  splitLocation.includes("critere_groupee") ||
                  splitLocation.includes("critere_groupee_detail")
                }
              />
            </StyledTreeItem>
          </StyledTreeItem>
        )}

        {hasPrivilege(contextData.privileges, "HR") && (
          <StyledTreeItem
            nodeId="5"
            labelText="RH"
            labelIcon={FaceTwoTone}
            isBold={true}
            link="/me/leaves"
            onClick={handleExpandClickRh}
          >
            {hasPrivilege(contextData.privileges, "Planning_leaving") && (
              <StyledTreeItem
                nodeId="5-1"
                labelText="Planification congé"
                labelIcon={ChevronRight}
                link="/me/leaves"
                isActiveMenu={pathname === "/me/leaves"}
              />
            )}
            {hasPrivilege(contextData.privileges, "Leave_request") && (
              <StyledTreeItem
                nodeId="5-2"
                labelText="Demande de congé"
                labelIcon={ChevronRight}
                link="/me/leave-request"
                isActiveMenu={pathname === "/me/leave-request"}
              />
            )}
            {/* {hasPrivilege(contextData.privileges, "Personnel_managing") && (
              <StyledTreeItem
                nodeId="5-3"
                labelText="Gestion du personnel"
                labelIcon={ChevronRight}
                link="/personnel"
                isActiveMenu={pathname === "/personnel"}
              />
            )} */}
            {hasPrivilege(contextData.privileges, "Sub_menu_annuaire") && (
              <StyledTreeItem
                nodeId="5-4"
                labelText="Annuaire"
                labelIcon={ChevronRight}
                link="/annuaire"
                isActiveMenu={pathname === "/annuaire"}
              />
            )}
            {hasPrivilege(contextData.privileges, "Information_of_family") && (
              <StyledTreeItem
                nodeId="5-5"
                labelText="Information sur la Famille"
                labelIcon={ChevronRight}
                link="/information_famille"
                isActiveMenu={pathname === "/information_famille"}
              />
            )}
            {hasPrivilege(contextData.privileges, "Leave_balance_summary") && (
              <StyledTreeItem
                nodeId="5-6"
                labelText="Historique Solde"
                labelIcon={ChevronRight}
                link="/leaveBalanceSummary"
                isActiveMenu={pathname === "/leaveBalanceSummary"}
              />
            )}
            {hasPrivilege(contextData.privileges, "Monthly_report") && (
              <StyledTreeItem
                nodeId="5-7"
                labelText="Historique rapport mensuel"
                labelIcon={ChevronRight}
                link="/monthly_report"
                isActiveMenu={pathname === "/monthly_report"}
              />
            )}
            {hasPrivilege(contextData.privileges, "timetracking_report_history") && (
              <StyledTreeItem
                nodeId="5-8"
                labelText="Historique situation présence"
                labelIcon={ChevronRight}
                link="/timeTracking_reportHistory"
                isActiveMenu={pathname === "/timeTracking_reportHistory"}
              />
            )}
            
            <StyledTreeItem
              nodeId="5-9"
              labelText="Pointage"
              labelIcon={ChevronRight}
              link="/timeTracking"
              isActiveMenu={pathname === "/timeTracking"}
            />
            <StyledTreeItem
              nodeId="5-10"
              labelText="Pointage Manuel"
              labelIcon={ChevronRight}
              link="/timeTrackingprovisional"
              isActiveMenu={
                pathname === "/timeTrackingprovisional" ? true : false
              }
            />
            {hasPrivilege(contextData.privileges, "evaluation_result") && (
              <StyledTreeItem
                nodeId="5-11"
                labelText="Resultat évaluation"
                labelIcon={ChevronRight}
                link="/resultats"
                isActiveMenu={pathname === "/resultats" ? true : false}
              />
            )}
            {hasPrivilege(contextData.privileges, "Compte_desactive") && (
              <>
                <StyledTreeItem
                  nodeId="5-13"
                  labelText="Comptes désactivés"
                  labelIcon={ChevronRight}
                  link="/user_notactif"
                  isActiveMenu={splitLocation.includes("user_notactif")}
                />
                <StyledTreeItem
                  nodeId="5-14"
                  labelText="Pointage manuel spécial"
                  labelIcon={ChevronRight}
                  link="/timetrackingtable"
                  isActiveMenu={splitLocation.includes("timetrackingtable")}
                />
              </>
            )}
            {hasPrivilege(contextData.privileges, "stg_permission") && (
              <StyledTreeItem
                nodeId="5-15"
                labelText="Demande de permission"
                labelIcon={ChevronRight}
                link="/leavestglist"
                isActiveMenu={splitLocation.includes("leavestglist")}
              />
            )}
          </StyledTreeItem>
        )}

        {hasPrivilege(contextData.privileges, "Banque de CV") && (
          <StyledTreeItem
            nodeId="6"
            labelText="Banque de CV"
            labelIcon={ListAlt}
            isBold={true}
            link="/cv_extern"
            onClick={handleExpandClickBanqueCV}
          >
            <StyledTreeItem
              nodeId="6-1"
              labelText="CV externe"
              labelIcon={ListAlt}
              link="/cv_extern"
            >
              <StyledTreeItem
                nodeId="6-1-1"
                labelText="Tous les candidats"
                labelIcon={ChevronRight}
                link="/cv_extern"
                isActiveMenu={location.pathname === "/cv_extern"}
              />
              <StyledTreeItem
                nodeId="6-1-2"
                labelText="Stagiaire"
                labelIcon={ChevronRight}
                link="/cv_stagiaire"
                isActiveMenu={location.pathname === "/cv_stagiaire"}
              />
              <StyledTreeItem
                nodeId="6-1-3"
                labelText="Candidat spontannée"
                labelIcon={ChevronRight}
                link="/cv_spontannee"
                isActiveMenu={location.pathname === "/cv_spontannee"}
              />
            </StyledTreeItem>
            
            {hasPrivilege(contextData.privileges, "CV Interne") && (
              <StyledTreeItem
                nodeId="6-2"
                labelText="CV Interne"
                labelIcon={ListAlt}
                link="/cv_intern"
              >
                <StyledTreeItem
                  nodeId="6-2-1"
                  labelText="Liste"
                  labelIcon={ChevronRight}
                  link="/cv_intern"
                  isActiveMenu={location.pathname === "/cv_intern"}
                />
                <StyledTreeItem
                  nodeId="6-2-2"
                  labelText="Détails"
                  labelIcon={ChevronRight}
                  link="/detail_cv_int"
                  isActiveMenu={location.pathname === "/detail_cv_int"}
                />
              </StyledTreeItem>
            )}
          </StyledTreeItem>
        )}

        {hasPrivilege(contextData.privileges, "Menu_Mission") && (
          <StyledTreeItem
            nodeId="7"
            labelText="Mission"
            labelIcon={CardTravel}
            isBold={true}
            onClick={handleExpandClickMission}
            link="/mission/planning_mission"
          >
            <StyledTreeItem
              nodeId="7-2"
              labelText="Mes demandes d'appui"
              labelIcon={ChevronRight}
              link="/mission/demande"
              isActiveMenu={pathname === "/mission/demande"}
            />
            <StyledTreeItem
              nodeId="7-4"
              labelText="Acceptation demande d'appui"
              labelIcon={ChevronRight}
              link="/acceptedHelp"
              isActiveMenu={splitLocation.includes("acceptedHelp")}
            />
            <StyledTreeItem
              nodeId="7-1"
              labelText="Planification"
              labelIcon={ChevronRight}
              link="/mission/planning_mission"
              isActiveMenu={pathname === "/mission/planning_mission"}
            />
            <StyledTreeItem
              nodeId="7-3"
              labelText="Elaboration TDR"
              labelIcon={ChevronRight}
              link="/mission/elaboration_tdr"
              isActiveMenu={pathname === "/mission/elaboration_tdr"}
            />
            <StyledTreeItem
              nodeId="7-4"
              labelText="Elaboration Agenda"
              labelIcon={ChevronRight}
              link="/mission/agendalist"
              isActiveMenu={pathname === "/mission/agendalist"}
            />
                 <StyledTreeItem
                  nodeId="7-5"
                  labelText="Elaboration Timesheet"
                  link="/mission/timesheet"
                  labelIcon={ChevronRight}
                  isActiveMenu={splitLocation.includes("timesheet") ? true : false}
                />
               
             <StyledTreeItem
                  nodeId="7-5"
                  labelText="Ordre des missions"
                  link="/mission/om"
                labelIcon={ChevronRight}
               isActiveMenu={pathname === "/mission/om" ? true : false}
                />
             <StyledTreeItem
                  nodeId="7-5-1"
                  labelText="Elaboration Décompte réel"
                  link="/mission/decompte"
                  labelIcon={ChevronRight}
                  isActiveMenu={pathname === "/mission/decompte" ? true : false}
                />
             
             {/* <StyledTreeItem
              nodeId="7-6"
              labelText="Historique demande"
              labelIcon={ChevronRight}
              link="/mission/history"
              isActiveMenu={pathname === "/mission/history"}
            /> */}
          </StyledTreeItem>
        )}
         {/* menu pour le comptable */}
         {hasPrivilege(contextData.privileges, "Comptable") && (
          <StyledTreeItem
            nodeId="8"
            labelText="Comptable"
            label="Comptable"
            labelIcon={CalculateIcon}
            isBold={true}
            onClick={handleExpandClickComptable}
            link="/accounting/mission_indemnity"
          >
              <StyledTreeItem
                nodeId="8-1"
                labelText="Mission"
                isBold={true}
                labelIcon={CardTravel}
                link="/accounting/mission_indemnity"
              >
                {/* <StyledTreeItem
                  nodeId="8-1-1"
                  labelText="Estimation Indemnités"
                  link="/accounting/mission_indemnity"
                  labelIcon={ChevronRight}
                  isActiveMenu={
                    pathname === "/accounting/mission_indemnity" ? true : false
                  }
                /> */}
                 <StyledTreeItem
                  nodeId="8-1-1"
                  labelText="Carburants/ indemnités prévisionnels"
                  link="/accounting/fuel_confirmed"
                  labelIcon={ChevronRight}
                  isActiveMenu={
                    pathname.includes("/accounting/fuel_confirmed") ? true : false
                  }
                />
                 <StyledTreeItem
                  nodeId="8-1-2"
                  labelText="Décomptes réels"
                  link="/accounting/decompte"
                  labelIcon={ChevronRight}
                  isActiveMenu={
                    pathname === "/accounting/decompte" ? true : false
                  }
                />
                 <StyledTreeItem
                  nodeId="8-1-3"
                  labelText="Paramétrage des indemnités"
                  link="/accounting/setting_indemnity"
                  labelIcon={ChevronRight}
                  isActiveMenu={
                    pathname === "/accounting/setting_indemnity" ? true : false
                  }
                />
                <StyledTreeItem
                  nodeId="8-1-4"
                  labelText="Élaborer la trame de mission"
                  link="/accounting/trame"
                  labelIcon={ChevronRight}
                  isActiveMenu={
                    pathname === "/accounting/trame" ? true : false
                  }
                />
              </StyledTreeItem>
          </StyledTreeItem>
          
        )}
        {hasPrivilege(contextData.privileges, "Menu_Logistique") && (
          <StyledTreeItem
            nodeId="9"
            labelText="Logistiques"
            labelIcon={ShopIcon}
            isBold={true}
            link="/logistic/immobilisations"
            onClick={handleExpandClickLogistic}
          >
            
            {hasPrivilege(contextData.privileges, "Menu_Logistique") && (
              <StyledTreeItem
                nodeId="9-1"
                labelText="Matériel"
                labelIcon={MonitorIcon}
                isBold={true}
                link="/logistic/immobilisations"
              >
                {hasPrivilege(contextData.privileges, "Logistique_Accès_Au_Menu_Catégories_Matériels") && (
                  <StyledTreeItem
                    nodeId="9-1-1"
                    labelText="Catégories matériels"
                    link="/logistic/category"
                    labelIcon={ChevronRight}
                    isActiveMenu={
                      pathname === "/logistic/category" ? true : false
                    }
                  />
                )}
                {hasPrivilege(contextData.privileges, "Accès_au_menu_Logistique_Classement_matériels") && (
                  <StyledTreeItem
                    nodeId="9-1-2"
                    labelText="Classements matériels"
                    link="/logistic/ranking"
                    labelIcon={ChevronRight}
                    isActiveMenu={pathname === "/logistic/ranking" ? true : false}
                  />
                )}
                <StyledTreeItem
                  nodeId="9-1-3"
                  labelText="Liste des Matériels"
                  link="/logistic/immobilisations"
                  labelIcon={ChevronRight}
                  isActiveMenu={
                    pathname === "/logistic/immobilisations" ? true : false
                  }
                />
                {hasPrivilege(contextData.privileges, "Accès_au_menu_Logistique_Génération_QrCode") && (
                  <StyledTreeItem
                    nodeId="9-1-3"
                    labelText="Génération QrCode"
                    link="/logistic/generateQrCode"
                    labelIcon={ChevronRight}
                    isActiveMenu={
                      pathname === "/logistic/generateQrCode" ? true : false
                    }
                  />
                )}
              </StyledTreeItem>
            )}
            {hasPrivilege(contextData.privileges, "Accès_au_menu_Logistique_Paramétrage_matériel") && (
              <StyledTreeItem
                nodeId="9-2"
                labelText="Paramétrage matériel"
                isBold={true}
                labelIcon={EditOffOutlinedIcon}
                link="/logistic/config"
              >
                {hasPrivilege(contextData.privileges, "Accès_au_menu_Logistique_Configuration_dun_matériel") && (
                  <StyledTreeItem
                    nodeId="9-2-1"
                    labelText="Configuration d'un matériel"
                    link="/logistic/config"
                    labelIcon={ChevronRight}
                    isActiveMenu={pathname === "/logistic/config"}
                  />
                )}
                {hasPrivilege(contextData.privileges, "Accès_au_menu_Logistique_Liste_des_configurations") && (
                  <StyledTreeItem
                    nodeId="9-2-2"
                    labelText="Liste des configurations"
                    link="/logistic/rankingList"
                    labelIcon={ChevronRight}
                    isActiveMenu={pathname === "/logistic/rankingList"}
                  />
                )}
              </StyledTreeItem>
            )}
            <StyledTreeItem
              nodeId="8-3"
              labelText="Historique d'inventaire"
              isBold={true}
              labelIcon={AssignmentOutlinedIcon}
              link="/logistic/inventory"
            >
              <StyledTreeItem
                nodeId="8-3-1"
                labelText="Matériel affecté"
                link="/logistic/inventory"
                labelIcon={ChevronRight}
                isActiveMenu={pathname === "/logistic/inventory"}
              />
              <StyledTreeItem
                nodeId="8-3-2"
                labelText="Matériels en stock"
                link="/logistic/stock"
                labelIcon={ChevronRight}
                isActiveMenu={pathname === "/logistic/stock"}
              />
            </StyledTreeItem>
            
            <StyledTreeItem
              nodeId="8-4"
              labelText="Statistique"
              labelIcon={ShowChart}
              isBold={true}
              link="/logistic/statistics"
              isActiveMenu={pathname === "/logistic/statistics"}
            />
            
            <StyledTreeItem
              nodeId="8-5"
              labelText="Réunion"
              isBold={true}
              labelIcon={MeetingRoomOutlinedIcon}
              link="/Logistic/meeting_management"
            >
              {hasPrivilege(contextData.privileges, "Admin-meeting-Add") && (
                <StyledTreeItem
                  nodeId="8-5-1"
                  labelText="Créer"
                  link="/Logistic/meeting_management/add"
                  labelIcon={ChevronRight}
                  isActiveMenu={pathname === "/Logistic/meeting_management/add"}
                />
              )}
              {hasPrivilege(contextData.privileges, "Admin-meeting-Request") && (
                <StyledTreeItem
                  nodeId="8-5-2"
                  labelText="Réunions"
                  link="/Logistic/meeting_management"
                  labelIcon={ChevronRight}
                  isActiveMenu={pathname === "/Logistic/meeting_management"}
                />
              )}
              <StyledTreeItem
                nodeId="8-5-3"
                labelText="Calendrier"
                link="/logistic/viewing_meeting"
                labelIcon={ChevronRight}
                isActiveMenu={pathname === "/logistic/viewing_meeting"}
              />
              <StyledTreeItem
                nodeId="8-5-4"
                labelText="Terminées"
                link="/Logistic/meeting_management/finish"
                labelIcon={ChevronRight}
                isActiveMenu={pathname === "/Logistic/meeting_management/finish"}
              />
            </StyledTreeItem>
        
         {hasPrivilege(contextData.privileges, "gestion_transport") && (
              <StyledTreeItem
                nodeId="9-6"
                labelText="Mission"
                isBold={true}
                labelIcon={CardTravel}
                link="/Logistic/mission/transport_managment"
              >
                <StyledTreeItem
                  nodeId="9-6-1"
                  labelText="Gestion des transports"
                  link="/Logistic/mission/transport_managment"
                  labelIcon={ChevronRight}
                  isActiveMenu={splitLocation.includes("transport_managment") ? true : false}
                />
                 {/* <StyledTreeItem
                  nodeId="9-6-2"
                  labelText="OM Chauffeur"
                  link="/Logistic/mission/OM_drivers"
                  labelIcon={ChevronRight}
                  isActiveMenu={splitLocation.includes("OM_drivers") ? true : false}
                /> */}
                  {/* <StyledTreeItem
                  nodeId="9-6-1"
                  labelText="Décompte de carburant prévisionnel"
                  link="/Logistic/mission/timesheet"
                  labelIcon={ChevronRight}
                  isActiveMenu={ pathname === "/Logistic/mission/timesheet"
                      ? true
                      : false}
                /> */}
                 <StyledTreeItem
                  nodeId="9-6-3"
                  labelText="Disponibilté des voitures"
                  link="/Logistic/mission/vehicle_managment"
                  labelIcon={ChevronRight}
                  isActiveMenu={splitLocation.includes("vehicle_managment") ? true : false}
                />
                <StyledTreeItem
                  nodeId="9-6-4"
                  labelText="Liste des voitures"
                  link="/Logistic/mission/vehicle"
                  labelIcon={ChevronRight}
                  isActiveMenu={splitLocation.includes("vehicle") ? true : false}
                />
                {/* <StyledTreeItem
                  nodeId="9-6-5"
                  labelText="Paramétrage des locations"
                  link="/Logistic/mission/rent_parameter"
                  labelIcon={ChevronRight}
                  isActiveMenu={splitLocation.includes("rent_parameter") ? true : false}
                /> */}
                <StyledTreeItem
                  nodeId="9-6-4"
                  labelText="Parametrage des carburants"
                  link="/Logistic/mission/fuel_parameter"
                  labelIcon={ChevronRight}
                  isActiveMenu={splitLocation.includes("fuel_parameter") ? true : false}
                />
              </StyledTreeItem>
            )}
         
          </StyledTreeItem>
        )}
        { hasPrivilege(contextData.privileges, "Gardien-Suivi") && (
          <StyledTreeItem
            nodeId="10"
            labelText="Mail regroupé"
            labelIcon={MailIcon}
            isBold={true}
            onClick={handleExpandClickMail}
            link=""
          >
            <StyledTreeItem
              nodeId="10-3"
              labelText="Envoyer"
              labelIcon={ChevronRight}
              link="/mailsend"
              isActiveMenu={pathname === "/mailsend" ? true : false}
            />
            <StyledTreeItem
              nodeId="10-2"
              labelText="Historique mail envoyé"
              labelIcon={ChevronRight}
              label="Historique mail envoyé"
              link="/mailhistory"
              isActiveMenu={pathname === "/mailhistory" ? true : false}
              // isActiveMenu={splitLocation.includes("acceptedHelp") ? true : false}
            />
            <StyledTreeItem
              nodeId="10-2"
              labelText="Historique mail reçu"
              labelIcon={ChevronRight}
              label="Historique mail reçu"
              link="/mailhistoryreceive"
              isActiveMenu={pathname === "/mailhistoryreceive" ? true : false}
              // isActiveMenu={splitLocation.includes("acceptedHelp") ? true : false}
            />
          </StyledTreeItem>
        )}

        { hasPrivilege(contextData.privileges, "Gardien-Gestion") && (
          <StyledTreeItem
            nodeId="d"
            labelText="Gestion du gardien"
            labelIcon={SecurityIcon}
            isBold={true}
            onClick={handleExpandClickSecurity}
            link="/gardian_list"
          >
            <StyledTreeItem
              nodeId="d-1"
              labelText="Liste des gardiens"
              labelIcon={ChevronRight}
              label="Liste des gardiens"
              link="/gardian_list"
              isActiveMenu={pathname === "/gardian_list" ? true : false}
            />
             {hasPrivilege(contextData.privileges, "Gardien-Add") && (
              <StyledTreeItem
                nodeId="d-2"
                labelText="Configurer jour de repos"
                labelIcon={ChevronRight}
                label="Configurer jour de repos"
                link="/gardian_add"
                isActiveMenu={pathname === "/gardian_add" ? true : false}
              />
             )}
              <StyledTreeItem
              nodeId="d-3"
              labelText="Suivi des jours de repos"
              labelIcon={ChevronRight}
              label="Suivi des jours de repos"
              link="/gardian_visual"
              isActiveMenu={pathname === "/gardian_visual" ? true : false}
            />
             <StyledTreeItem
              nodeId="d-4"
              labelText="Situation presence"
              labelIcon={ChevronRight}
              label="Situation presence"
              link="/timeTracking_gardian"
              isActiveMenu={pathname === "/timeTracking_gardian" ? true : false}
            />
          </StyledTreeItem>
        )}

        {/* {hasPrivilege(contextData.privileges, "Evaluation_personnel") && ( */}
          <>
            <StyledTreeItem
              nodeId="a"
              labelText="Evaluation du personnel"
              labelIcon={PsychologyAltOutlinedIcon}
              isBold={true}
              onClick={handleExpandClickPersonnalEvaluation}
              link="/personnel_evaluation"
            >
              <StyledTreeItem
                nodeId="a-1"
                labelText="Evaluation"
                labelIcon={ChevronRight}
                link="/personnel_evaluation"
                isActiveMenu={splitLocation.includes("personnel_evaluation")}
              />
              <StyledTreeItem
                nodeId="a-2"
                labelText="Mes équipes"
                labelIcon={ChevronRight}
                link="/mes_subordonnees"
                isActiveMenu={splitLocation.includes("mes_subordonnees")}
              />
            </StyledTreeItem>
              </>
        {/* )} */}
            
        {hasPrivilege(contextData.privileges, "gestion_contrat") && (
          <>
            <StyledTreeItem
              nodeId="f"
              labelText="Gestion de contrat"
              labelIcon={FolderSharedIcon}
              isBold={true}
              onClick={handleExpandClickContract}
              link="/contract_stg"
            >
              <StyledTreeItem
                nodeId="f-1"
                labelText="Contrat Personnel"
                labelIcon={ChevronRight}
                link="/contract_user"
                isActiveMenu={splitLocation.includes("contract_user")}
              />
              <StyledTreeItem
                nodeId="f-2"
                labelText="Contrat Stagiaire"
                labelIcon={ChevronRight}
                link="/contract_stg"
                isActiveMenu={splitLocation.includes("contract_stg")}
              />
            </StyledTreeItem>
            </>
        )}


        {hasPrivilege(contextData.privileges, "gestion_formation") && (
          <> 
          <StyledTreeItem
              nodeId="g"
              labelText="Gestion de formation"
              labelIcon={FolderSharedIcon}
              isBold={true}
              onClick={handleExpandClickFormation}
              link="/classes"
            >
              <StyledTreeItem
                nodeId="g-1"
                labelText="Classes"
                labelIcon={ChevronRight}
                link="/classes"
                isActiveMenu={splitLocation.includes("classes")}
              />
              <StyledTreeItem
                nodeId="g-2"
                labelText="Matières"
                labelIcon={ChevronRight}
                link="/matieres"
                isActiveMenu={splitLocation.includes("matieres")}
              />
               <StyledTreeItem
                nodeId="g-3"
                labelText="Cours & QCM"
                labelIcon={ChevronRight}
                link="/cours"
                isActiveMenu={splitLocation.includes("cours")}
              />
              <StyledTreeItem
                nodeId="g-4"
                labelText="Evaluations"
                labelIcon={ChevronRight}
                link="/evaluations"
                isActiveMenu={splitLocation.includes("evaluations")}
              />
        </StyledTreeItem>
          </>
        )}

        {/* /////// */}
        <StyledTreeItem
          nodeId="11"
          labelText="Mon compte"
          labelIcon={AccountCircle}
          isBold={true}
          link="/myAccount"
          isActiveMenu={pathname === "/myAccount"}
        />

        {hasPrivilege(contextData.privileges, "mes_materiels") && (
          <StyledTreeItem
            nodeId="j"
            labelText="Mes matériels"
            labelIcon={MonitorIcon}
            isBold={true}
            link="/logistic/me/inventory"
            onClick={handleExpandClickMesMateriels}
          >
            <StyledTreeItem
              nodeId="j-1"
              labelText="Mes matériels affectés"
              labelIcon={ChevronRight}
              link="/logistic/me/inventory"
              isActiveMenu={pathname === "/logistic/me/inventory"}
            />
            <StyledTreeItem
              nodeId="j-2"
              labelText="Autres et Affectation"
              labelIcon={ChevronRight}
              link="/logistic/others/inventory"
              isActiveMenu={pathname === "/logistic/others/inventory"}
            />
          </StyledTreeItem>
        )}
      </TreeView>
    </>
  );
}

export default SidebarTreeView;
